import styled from 'styled-components';

export const StyledResendModal = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 500px;
  min-height: 300px;

  .title {
    max-width: 390px;
    flex-wrap: wrap;
  }

  .footer {
    display: flex;
    justify-content: center;
    gap: 20px;
  }
`;
